import i18n from 'src/i18n';

const MixinComputed = {
  computed: {
    getColHeaders: () => {
      return [
        i18n.t('production.net_weight'),
        i18n.t('production.ribbon_id'),
        i18n.t('production.ribbon'),
        i18n.t('common_words.allotment'),
        i18n.t('production.crew_division'),
        i18n.t('production.n_hands'),
        i18n.t('production.second_caliber'),
        i18n.t('production.second_large'),
        i18n.t('production.lst_large'),
        i18n.t('production.denegation'),
        i18n.t('common_words.status'),
        i18n.t('labor.hour_quality'),
        i18n.t('common_words.hour'),
      ];
    },

    getColXR5000PHONE: () => {
      return [
        i18n.t('production.net_weight'),
        i18n.t('production.ribbon_id'),
        i18n.t('production.ribbon'),
        i18n.t('common_words.allotment'),
        i18n.t('production.crew_division'),
        i18n.t('production.n_hands'),
        i18n.t('production.second_caliber'),
        i18n.t('production.second_large'),
        i18n.t('production.lst_large'),
        i18n.t('production.denegation'),
        i18n.t('common_words.hour'),
      ];
    },

    getColXR5000PC: () => {
      return [
        i18n.t('production.net_weight'),
        i18n.t('production.ribbon_id'),
        i18n.t('production.ribbon'),
        i18n.t('common_words.allotment'),
        i18n.t('production.crew_division'),
        i18n.t('production.n_hands'),
        i18n.t('production.second_caliber'),
        i18n.t('production.second_large'),
        i18n.t('production.lst_large'),
        i18n.t('production.denegation'),
        i18n.t('common_words.user'),
        i18n.t('common_words.modified'),
        i18n.t('common_words.notes'),
        i18n.t('common_words.hour'),
      ];
    },

    getColXR3000: () => {
      return [
        'IDV',
        i18n.t('production.net_weight'),
        i18n.t('production.ribbon_id'),
        i18n.t('production.ribbon'),
        i18n.t('common_words.allotment'),
        i18n.t('production.crew_division'),
        i18n.t('production.n_hands'),
        i18n.t('production.second_caliber'),
        i18n.t('production.second_large'),
        i18n.t('production.lst_large'),
        i18n.t('production.denegation'),
      ];
    },
  },
};

export { MixinComputed };
